import { API } from '../api';
import { notifyError } from './utils';

export const parseSearchParam = (params: any) => {
  let searchParam = {
    q: params?.q || '',
    orderNo: params?.orderNo || '',
    barcode: params?.barcode || '',
    isPrint: typeof params?.isPrint === 'boolean' ? params?.isPrint : '',
    orderStartDate: params?.orderStartDate || '',
    orderEndDate: params?.orderEndDate || '',
    scanStartDate: params?.scanStartDate || '',
    scanEndDate: params?.scanEndDate || '',
    senderQ: params?.senderQ || '',
    receiverQ: params?.receiverQ || '',
    scanBranchNo: params?.scanBranchNo || '',
    lastBranchNo: params?.lastBranchNo || '',
    deliveryManNo: params?.deliveryManNo || '',
    customerNo: params?.customerNo || '',
    provinceNo: params?.provinceNo || '',
    districtNo: params?.districtNo || '',
    deliveryType: params?.deliveryType || '',
    svc: params?.svc || '',
    page: params?.page || 1,
    size: params?.size || 10,
  };

  return searchParam;
};

export const orderDownload = async (search: string, status: string) => {
  try {
    const response = await API.get({
      apiVersion: 'api',
      responseType: 'blob',
    })(`/order/export${search}&status=${status}`);
    const downloadUrl = window.URL.createObjectURL(response.data);
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.setAttribute('download', 'data.xlsx');
    document.body.appendChild(link);
    link.click();
  } catch (errro: any) {
    notifyError(errro.message);
  }
};
